<mat-form-field
  class="w-full text-project-50"
  [ngClass]="{
    'on-error': control.hasError('required'),
    'mention-flash': isFlashed
  }"
  [appearance]="'outline'"
>
  <textarea
    type="text"
    rows="3"
    maxlength="256"
    matInput
    [name]="'Standfirst'"
    [formControl]="control"
    placeholder="Standfirst"
    class="text-project-1400"
  ></textarea>
</mat-form-field>
